import list from './list'
import get from './get'

export default {
    list,
    get,
}
